export default __webpack_public_path__ + "static/survey-insights-light-mode-bc65700ee2459756f42cfdfc3610f3a7.mp4";